
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemePaymentDetailsDialog extends Common.GridEditorDialog<SchemePaymentDetailsRow> {
        protected getFormKey() { return SchemePaymentDetailsForm.formKey; }
        //protected getIdProperty() { return SchemePaymentDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return SchemePaymentDetailsRow.localTextPrefix; }
        //protected getService() { return SchemePaymentDetailsService.baseUrl; }
        protected getDeletePermission() { return SchemePaymentDetailsRow.deletePermission; }
        protected getInsertPermission() { return SchemePaymentDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SchemePaymentDetailsRow.updatePermission; }

        protected form = new SchemePaymentDetailsForm(this.idPrefix);
        constructor() {
            super();
            this.form.ModeId.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                this.form.LedgerId.value = ledger.LedgerId;
                if (ledger.Type == 280) { //For Gift Voucher
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 282 || ledger.Type == 287) { //For Visa/MAsterCard/UPI
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
               
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.RefNo, true);
                }
                this.form.RefNo.value = "";

            });

        }

        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ModeId.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                if (ledger.Type == 280) { //For Gift Voucher
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 282 || ledger.Type == 287) { //For Visa/MAsterCard/UPI
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.RefNo, true);
                }


            } else {
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
                q.hideField(this.form.RefNo, true);
            }
        }

    }
}